import { DraftFaq } from '../../types/faqs';

export function isNewFaq(faq: DraftFaq): boolean {
  return faq.id.startsWith('new:');
}

export function newFaqId(): string {
  return `new:${crypto.randomUUID()}`;
}

export function addFaq(faqs: DraftFaq[]): DraftFaq[] {
  return [...faqs, { id: newFaqId(), header: '', text: '' }];
}

export function editFaq(
  faqs: DraftFaq[],
  id: string,
  patch: Partial<Pick<DraftFaq, 'header' | 'text'>>,
): DraftFaq[] {
  return faqs.map(faq => (faq.id === id ? { ...faq, ...patch } : faq));
}

export function removeFaq(faqs: DraftFaq[], id: string): DraftFaq[] {
  return faqs.filter(faq => faq.id !== id);
}

export function isValidFaq(faq: DraftFaq): boolean {
  return !!faq.header.trim() && !!faq.text.trim();
}

export function toUpsertFaq(faq: DraftFaq) {
  return {
    faqId: isNewFaq(faq) ? undefined : faq.id,
    header: faq.header,
    text: faq.text,
  };
}
